import { QueryClient } from '@tanstack/react-query';

// Configuración del QueryClient para la gestión de caché y solicitudes
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minutos
      gcTime: 5 * 60 * 1000, // 5 minutos
      retry: 2, // Reintentar 2 veces en caso de error
      refetchOnWindowFocus: false, // No volver a buscar datos al enfocar la ventana
      refetchInterval: 5 * 60 * 1000, // Refrescar datos cada 5 minutos en segundo plano
    },
  },
});

export default queryClient;